import {
  AutocompleteArrayInput,
  BooleanInput,
  ReferenceArrayInput,
} from "react-admin";
import React, { useEffect, useState } from "react";
import { useField } from "react-final-form";

const ParentsInput = () => {
  const notificationTargetTypeField = useField("notificationTargetType");
  const routeInput = useField("routeIds");
  const schoolInput = useField("schoolId");
  const busScheduleInput = useField("busScheduleIds");

  const isSendToAllField = useField("isSendToAllParents");
  const parentIdsField = useField("parentIds");
  const [isDisabled, setIsDisabled] = useState<boolean>(false);
  const [isFocused, setIsFocused] = useState<boolean>(false);

  useEffect(() => {
    if (isSendToAllField.input.value) {
      setIsDisabled(true);
      parentIdsField.input.onChange([]);
    } else {
      setIsDisabled(false);
      parentIdsField.input.onChange([]);
    }
  }, [isSendToAllField.input.value]);

  const filter = (targetType: string) => {
    let filter;
    switch (targetType) {
      case "school":
        filter = { SchoolId: Number(schoolInput.input.value) };
        break;
      case "bus_schedule":
        filter = { BusScheduleIds: busScheduleInput.input.value };
        break;
      case "route":
        filter = { RouteIds: routeInput.input.value };
        break;
    }

    return filter;
  };

  const handleFocus = () => {
    setIsFocused(true);
  };

  const handleBlur = () => {
    setIsFocused(false);
  };

  return (
    <>
      <ReferenceArrayInput
        label="Parent"
        source="parentIds"
        reference="listParentsForNotification"
        filter={isFocused ? filter(notificationTargetTypeField.input.value) : {}}
        filterToQuery={(searchText: string) => {
          if (searchText !== "") return { search: searchText };
        }}
        sort={{ field: "firstName", order: "ASC" }}
        onFocus={handleFocus}
        onBlur={handleBlur}
        disabled={isDisabled}
      >
        <AutocompleteArrayInput
          optionText={(choice: any) => `${choice.firstName} ${choice.lastName}`}
          debounce={1000}
        />
      </ReferenceArrayInput>
      <BooleanInput label="Send To All Parents" source="isSendToAllParents" />
    </>
  );
};

export default ParentsInput;
